<template>
  <div class="purchaseReceives">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="采购收货单详情"
        class="customer-edit"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="purchase"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div slot="toolbar">
          <el-button type="primary" style="margin-bottom: 3%">打印</el-button>
        </div>
        <table
            class="table"
            cellpadding="0"
            cellspacing="0"
            width="100%">
          <tr v-if="value === 'edit'">
            <td style="width: 33.3%">
              <span>编号:</span>{{purchase.no}}
            </td>
            <td style="width: 66.7%">
              <span style="width: 13%">采购组:</span>{{purchase.buyUserName}}
            </td>
          </tr>
          <tr v-if="value === 'index'">
            <td>
              <span>编号:</span>{{purchase.no}}
            </td>
            <td>
              <span>采购组:</span>{{purchase.buyUserName}}
            </td>
            <td>
              <span style="border-left: 1px solid #cccccc">收货创建日期:</span>{{purchase.createdTime}}
            </td>
          </tr>
          <tr>
            <td>
              <span>采购订单号:</span>{{purchase.buyOrderNO}}
            </td>
            <td>
              <span>供应商:</span>{{purchase.gysName}}
            </td>
            <td>
              <span style="border-left: 1px solid #cccccc">订单创建时间:</span>{{purchase.requiredArrivalDate}}
            </td>
          </tr>
          <tr>
            <td style="border-bottom: none">
              <span>联系人:</span>{{purchase.linkMan}}
            </td>
            <td style="border-bottom: none">
              <span>电话:</span>{{purchase.linkManPhone}}
            </td>
            <td style="border-bottom: none">
              <span style="border-left: 1px solid #cccccc">传真:</span>{{purchase.linkManFax}}
            </td>
          </tr>
        </table>
        <div style="border: 1px solid #f5f5f5;margin: 3% auto;padding: 2%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="要求到货日期">
                <el-date-picker
                    v-model="purchase.plannedArrivalTime"
                    align="right"
                    disabled
                    type="date"
                    placeholder="选择日期"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="实际到货日期">
                <el-date-picker
                    v-model="purchase.arrivedTime"
                    align="right"
                    disabled
                    type="date"
                    placeholder="选择日期"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input v-model="purchase.note" type="textarea" disabled placeholder="请输入"/>
          </el-form-item>
        </div>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="物料信息" name="first">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
              <el-table-column
                  prop="rowIndex"
                  align="center"
                  label="序号"/>
              <el-table-column
                  prop="sapmaterialNO"
                  align="center"
                  label="物料编号"/>
              <el-table-column
                  prop="sapmaterialName"
                  width="180px"
                  align="center"
                  label="物料名称"/>
              <el-table-column
                  prop="requireDeliveryDate"
                  width="180px"
                  align="center"
                  label="采购订单交期"/>
              <el-table-column
                  prop="sumQuantity"
                  align="center"
                  label="采购数量"/>
              <el-table-column
                  prop="instockQuantity"
                  align="center"
                  label="已购数量"/>
              <el-table-column
                  prop="quantity"
                  align="center"
                  label="送货数量"/>
            </el-table>
          </el-tab-pane>

          <el-tab-pane v-if="value === 'edit'" label="附件信息" name="second">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
              <el-table-column
                  prop="sapmaterialNO"
                  align="center"
                  label="文件分类"/>
              <el-table-column
                  prop="sapmaterialName"
                  width="180px"
                  align="center"
                  label="文件名"/>
              <el-table-column
                  prop="requireDeliveryDate"
                  width="180px"
                  align="center"
                  label="创建者"/>
              <el-table-column
                  prop="sumQuantity"
                  align="center"
                  label="创建时间"/>
              <el-table-column
                  label="操作"
                  align="center"
                  class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"Preview",
    components: {},
    data() {
      return {
        constant,
        statu:constant.toSelect(constant.purchaseStatus,"addAll"),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        activeName: "first",
        value: "",
        purchase: {
          no: "",
          purchaseOrderNO: "",
          buyOrderNO: "",
          status: "",
          receiveStatus: "",
          creatorName: "",
          createdTime: "",
          arrivedTime: "",
          gysName: "",
          buyUserName: "",
          linkMan: "",
          linkManFax: "",
          linkManPhone: "",
          requiredArrivalDate: "",
          plannedArrivalTime: "",
          planAddDateBegin: "",
          planAddDateEnd: "",
          autcalDateBegin: "",
          autcalDateEnd: "",
          receiveDetails: [],
        },
        ruleValidate: {
          postName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id,val) {
        this.value = val;
        console.log(id);
        this.purchase.pkid = id;
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `purchaseReceives/${this.purchase.pkid}`)
          .then(resp => {
            this.purchase = resp;
            console.log(this.purchase.status);
            for(let item of resp.receiveDetails) {
              item.quantity = item.sumQuantity;
            }
            this.tableData = resp.receiveDetails;
            console.log(this.tableData);
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
    .purchaseReceives{
        .el-form-item__content{
            margin-left: 2%!important;
        }
        .table{
            width: 100%;
            border: 1px solid #cccccc;
            margin-bottom: 3%;
            tr{
                display: flex;
                flex-direction: row;
                td{
                    width: 33.5%;
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #cccccc;
                    display: flex;
                    flex-direction: row;
                    padding: 0;
                    span{
                        display: block;
                        padding-right: 2%;
                        margin-right: 2%;
                        width: 28%;
                        height: 40px;
                        line-height: 40px;
                        background: #f5f5f5;
                        border-right: 1px solid #cccccc;
                        text-align: right;
                    }
                    .el-radio {
                        line-height: 40px;
                    }
                }
                td:nth-child(1){
                    border-right: 1px solid #cccccc;
                }
            }
        }
    }
</style>
